import React from 'react'
import { CloseCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import MediaAvatar from '@SonarCX/components/atoms/MediaAvatar'
import Tooltip from '@SonarCX/components/atoms/Tooltip'

import useStyles from './styles'

type AssigneeProps = {
  user: LocalUser
  onDelete?: () => void
  disableTooltip?: boolean
  intersect: IntersectionObserverEntry
}

const UserListItem: React.FC<AssigneeProps> = ({
  user,
  onDelete,
  disableTooltip,
  intersect
}) => {
  const theme = useTheme()

  const classes = useStyles()

  return (
    <Tooltip key={user.id} title={disableTooltip ? null : user.name} arrow>
      <div className={classes.root}>
        <MediaAvatar
          user={user}
          className={classes.avatar}
          intersect={intersect}
        />

        {onDelete && (
          <CloseCircle
            onClick={onDelete}
            size={theme.size.base}
            color='#aaa'
            className='icon'
          />
        )}
      </div>
    </Tooltip>
  )
}

export default React.memo(UserListItem)
